import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Text = makeShortcode("Text");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Text sx={{
      fontSize: [4, 5, 6],
      fontWeight: `bold`,
      color: `heading`
    }} mdxType="Text">
  Hi.
    </Text>
    <p>{`My name is Jay Sawant. I am a full-stack web developer and UI/UX enthusiast. Welcome to my blog, here you will find a few of my personal projects along with some cool tips and tricks 😉`}</p>
    <p>{`Remotely available UTC-13 to UTC-18. `}<a parentName="p" {...{
        "href": "mailto:contact@jsawant.com"
      }}>{`contact@jsawant.com`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      